import insertNodeAfter from "../../utils/insertNodeAfter";

export function processParticleWrapperAttributes(wrapper, config) {
    const { id, href, basename, publishedAt } = config;
    wrapper.id = `rebelltitem${id}`;
    wrapper.setAttribute("data-id", id);
    wrapper.setAttribute("data-href", href);
    wrapper.setAttribute("data-basename", basename);
    if (isNaN(publishedAt)) {
        wrapper.setAttribute("data-published-at", new Date(`${publishedAt}Z`).getTime() / 1000);
    } else {
        wrapper.setAttribute("data-published-at", publishedAt / 1000);
    }
}

export function insertParticle(container, particle) {
    if (particle) {
        insertNodeAfter(container.querySelectorAll("[data-id]")[0], particle);
    }
}
